import React from 'react';
import { MessageCircle, Mail, X } from 'lucide-react';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-1">
      <div className="relative max-w-md w-full bg-[#0F111A] rounded-3xl border border-white/10 shadow-2xl p-8" data-id="element-2">
        <button onClick={onClose} className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md flex items-center justify-center transition-colors border border-white/20" data-id="element-3">
          <X className="w-5 h-5 text-white" data-id="element-4" />
        </button>

        <h2 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-5">
          Contáctanos
        </h2>
        <p className="text-text-secondary mb-8" data-id="element-6">
          Elige tu método de contacto preferido
        </p>

        <div className="space-y-4" data-id="element-7">
          <a href="https://wa.me/573135250384?text=Hola%20Krove%20Latam%2C%20estoy%20interesad%40%20en%20tus%20servicios." target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-2xl bg-[#25D366]/10 border border-[#25D366]/30 hover:bg-[#25D366]/20 transition-all duration-300 group" data-id="element-8">
            <div className="w-12 h-12 rounded-full flex items-center justify-center shrink-0" data-id="element-9">
              <img src="https://cdn.magicpatterns.com/uploads/9SXGXM2tMXyypcdQ5ijcxp/logo_whatsapp.png" alt="WhatsApp" className="w-full h-full object-contain" data-id="element-10" />
            </div>
            <div className="flex-1" data-id="element-11">
              <h3 className="text-white font-medium mb-1" data-id="element-12">WhatsApp</h3>
              <p className="text-sm text-text-secondary" data-id="element-13">+57 313 525 0384</p>
            </div>
          </a>

          <a href="mailto:krove.lat@gmail.com?subject=Consulta%20sobre%20servicios&body=Hola%20Krove%20Latam%2C%20estoy%20interesad%40%20en%20tus%20servicios." className="flex items-center gap-4 p-4 rounded-2xl bg-primary/10 border border-primary/30 hover:bg-primary/20 transition-all duration-300 group" data-id="element-14">
            <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center shrink-0" data-id="element-15">
              <Mail className="w-6 h-6 text-white" data-id="element-16" />
            </div>
            <div className="flex-1" data-id="element-17">
              <h3 className="text-white font-medium mb-1" data-id="element-18">
                Correo Electrónico
              </h3>
              <p className="text-sm text-text-secondary" data-id="element-19">krove.lat@gmail.com</p>
            </div>
          </a>
        </div>
      </div>
    </div>;
}